// D24 (roles prod promotion, Stage 3, 2026-09-25): the options of the two user-management
// role pickers (Create/Edit User and the user list's "Filter by role"), as pure helpers so the
// rules are unit-tested (LEAF module, no imports).

// May the caller give a user this role? The role list marks each row `assignable` (held by the
// caller, the caller's OWN role included - D24 (i)); while an older backend sends only
// `editable` (which leaves out the caller's own role, because nobody may EDIT the role they
// wear), fall back to it. A grant-all administrator (metaData.unscopedAdmin) may assign any role.
export const isAssignable = (role, unscopedAdmin) =>
  !!unscopedAdmin ||
  (!!role &&
    (typeof role.assignable === "boolean" ? role.assignable : !!role.editable));

// Create/Edit User: every role the caller may assign, plus the user's CURRENT role, which is
// shown even when the caller cannot assign it but is then not selectable - so editing a user
// never blanks the field or silently changes their role. Keeps the role list's order.
export function userRoleOptions(roles, currentRoleId, unscopedAdmin) {
  const current =
    currentRoleId != null && currentRoleId !== "" ? String(currentRoleId) : null;
  return (roles || [])
    .filter((r) => r && r._id != null)
    .map((r) => ({
      _id: String(r._id),
      name: r.name || "",
      disabled: !isAssignable(r, unscopedAdmin),
    }))
    .filter((o) => !o.disabled || o._id === current);
}

// "Filter by role": only the role names shown on the listed user rows (row.role is the
// resolved role name), sorted, without blanks or repeats.
export function roleFilterOptions(rows) {
  return [
    ...new Set(
      (rows || [])
        .map((r) => r && r.role)
        .filter((name) => typeof name === "string" && name)
    ),
  ].sort((a, b) => a.localeCompare(b));
}
